<div class="line">
  <ms-form-field data-cy="VoiceResultsForm" appearance="classic" color="green">
    <ms-checkbox gameParameter="voiceResults" [color]="color">
      {{ 'commentCompletedExample' | translate }}
    </ms-checkbox>
  </ms-form-field>
</div>
<div class="line" *ngIf="!taskEndSongHidden">
  <ms-form-field data-cy="TaskEndSongForm" appearance="classic" color="green">
    <ms-checkbox gameParameter="taskEndSong" [color]="color">
      {{ 'menar.taskEndSong' | translate }}
    </ms-checkbox>
  </ms-form-field>
</div>
